<template>
  <div class="filter-container">
    <!-- 酒店-全部订单 -->
    <template v-if="htpath == 'htall'">
      <el-input v-model="listquery.filter.order_sn" :placeholder="$t('order.EnterOrderNumber')" class="filter-item w140" clearable />
      <el-input v-model="listquery.filter.username" :placeholder="$t('order.hotel.name')" class="filter-item" style="width: 120px;" clearable />
      <el-select v-model="listquery.filter.order_status" :placeholder="$t('order.order_status')" clearable style="width: 120px;" class="filter-item">
        <el-option :label="$t('order.Checkedin')" value="5" />
        <el-option v-for="(item,key) in order_status.options" :key="key" :label="item" :value="key" />
      </el-select>
      <el-select v-model="listquery.filter.product" :placeholder="$t('order.HotelName')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in product_id.options" :key="key" :label="item.value" :value="item.value" />
      </el-select>
      <!-- 房间类型 -->
      <el-select v-model="listquery.filter.product_model_id" :placeholder="$t('order.room_type')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in room_type_list.options" :key="key" :label="item" :value="key" />
      </el-select>
      <el-select v-model="listquery.filter.client_type" :placeholder="$t('order.client_type')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in client_type.options" :key="key" :label="item" :value="key" />
      </el-select>
      <el-date-picker v-for="(item,key) in chose_time" :key="key" v-model="listquery.filter[key]" type="date" :placeholder="item.plac" style="width: 150px;margin-right: 5px" class="filter-item" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
    </template>

    <!-- 酒店-退款订单 -->
    <template v-else-if="filterName == 'hotel_order_refund'">
      <el-input v-model="listquery.filter.order_sn" :placeholder="$t('order.Inputrefundnumber')" class="filter-item w140" clearable />
      <el-date-picker v-for="(item,key) in refund_chose_time" :key="key" v-model="listquery.filter[key]" type="date" :placeholder="item.plac" style="width: 150px;margin-right: 5px" class="filter-item" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
      <el-select v-model="listquery.filter.order_status" :placeholder="$t('order.order_status')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in refund_order_status.options" :key="item" :label="item" :value="key" />
      </el-select>
    </template>

    <!-- 酒店-虚拟订单 -->
    <template v-if="filterName == 'hotel_order_virtual'">
      <el-button class="filter-item" type="primary" @click="addOrderVisible = true">{{ $t('order.Enterorders') }}</el-button>
      <el-select v-model="listquery.filter.product" :placeholder="$t('order.HotelName')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in product_id.options" :key="key" :label="item" :value="item" />
      </el-select>
      <el-input v-model="listquery.filter.remark" :placeholder="$t('order.Stayinstructions')" style="width: 120px;" class="filter-item" clearable />
      <el-date-picker v-model="listquery.filter.start_time_start" type="date" :placeholder="$t('order.Checktimebegins')" style="width: 150px;margin-right: 5px" class="filter-item" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
      <el-date-picker v-model="listquery.filter.start_time_end" type="date" :placeholder="$t('order.Checkdeadline')" style="width: 150px;margin-right: 5px" class="filter-item" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
    </template>

    <!-- SPA-全部订单 -->
    <template v-else-if="filterName == 'spa_order_list'">
      <el-input v-model="listquery.filter.order_sn" :placeholder="$t('order.EnterOrderNumber')" class="filter-item w140" clearable />
      <el-date-picker v-model="listquery.filter.start_time_start" type="date" :placeholder="$t('order.start_time')" style="width: 150px;margin-right: 5px" class="filter-item" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
      <el-select v-model="listquery.filter.client_type" :placeholder="$t('order.client_type')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in client_type.options" :key="key" :label="item" :value="key" />
      </el-select>
      <el-select v-model="listquery.filter.order_status" :placeholder="$t('order.order_status')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in order_status.options" :key="item" :label="item" :value="key" />
      </el-select>
    </template>

    <!-- SPA-退款订单 -->
    <template v-else-if="filterName == 'spa_order_refund'">
      <el-date-picker v-model="listquery.filter.start_time_start" type="date" :placeholder="$t('order.start_time')" style="width: 150px;margin-right: 5px" class="filter-item" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
      <el-select v-model="listquery.filter.client_type" :placeholder="$t('order.client_type')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in client_type.options" :key="key" :label="item" :value="key" />
      </el-select>
    </template>

    <!-- 靶场-全部订单 -->
    <template v-else-if="filterName == 'club_order_list'">
      <el-input v-model="listquery.filter.order_sn" :placeholder="$t('order.EnterOrderNumber')" class="filter-item w140" clearable />
      <el-date-picker v-model="listquery.filter.start_time_start" type="date" :placeholder="$t('order.start_time')" style="width: 150px;margin-right: 5px" class="filter-item" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
      <el-select v-model="listquery.filter.client_type" :placeholder="$t('order.client_type')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in client_type.options" :key="key" :label="item.name" :value="item.id" />
      </el-select>
      <el-select v-model="listquery.filter.order_status" :placeholder="$t('order.order_status')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in order_status.options" :key="item" :label="item" :value="key" />
      </el-select>
    </template>

    <!-- 靶场-退款订单 -->
    <template v-else-if="filterName == 'club_order_refund'">
      <el-date-picker v-model="listquery.filter.start_time_start" type="date" :placeholder="$t('order.start_time')" style="width: 150px;margin-right: 5px" class="filter-item" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
      <el-select v-model="listquery.filter.client_type" :placeholder="$t('order.client_type')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in client_type.options" :key="key" :label="item" :value="key" />
      </el-select>
    </template>

    <!-- 车队-全部订单 -->
    <template v-else-if="filterName == 'car_order_list'">
      <el-input v-model="listquery.filter.order_sn" :placeholder="$t('order.EnterOrderNumber')" class="filter-item w140" clearable />
      <el-date-picker v-model="listquery.filter.start_time_start" type="date" :placeholder="$t('order.car.start_time')" style="width: 150px;margin-right: 5px" class="filter-item" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
      <el-select v-model="listquery.filter.client_type" :placeholder="$t('order.client_type')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in client_type.options" :key="key" :label="item" :value="key" />
      </el-select>
      <el-select v-model="listquery.filter.order_status" :placeholder="$t('order.order_status')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in order_status.options" :key="item" :label="item" :value="key" />
      </el-select>
    </template>

    <!-- 车队-退款订单 -->
    <template v-else-if="filterName == 'car_order_refund'">
      <el-date-picker v-model="listquery.filter.start_time_start" type="date" :placeholder="$t('order.car.start_date')" style="width: 150px;margin-right: 5px" class="filter-item" value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
      <el-select v-model="listquery.filter.client_type" :placeholder="$t('order.client_type')" clearable style="width: 120px;" class="filter-item">
        <el-option v-for="(item,key) in client_type.options" :key="key" :label="item" :value="key" />
      </el-select>
    </template>

    <!-- 筛选&刷新 -->
    <el-button class="filter-item" type="primary" @click="filter">{{ $t('setting.filter') }}</el-button>
    <!-- <el-button class="filter-item" type="primary" @click="xlsxlist">导出</el-button> -->
    <!-- <el-button class="filter-item" type="primary" circle @click="refresh">
      <svg-icon icon-class="refresh" />
    </el-button> -->

    <!-- 录入订单弹窗 -->
    <el-dialog :title="$t('order.Enterorders')" :visible.sync="addOrderVisible" top="15vh" width="85%" center custom-class="dialog dialog2">
      <hotel :title="$t('route.virtualOrders')" :order-type="'VIRTUAL'" @closedialog="closedialog" @submit="virtualOrders" />
    </el-dialog>
  </div>
</template>

<script>
import { hotelRoomelist, validList } from '@/api/order'
import hotel from '../hotel'
export default {
  components: {
    hotel
  },
  props: {
    listquery: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      filterName: '',
      list_type: '',
      offlinorder_type: '',
      order_status: {
        plac: this.$t('order.order_status'),
        val: '',
        options: {
          '0': this.$t('order.Tobesubmitted'),
          '2': this.$t('order.Tobepaid'),
          '3': this.$t('order.confirmed'),
          '4':
            this.listquery.filter.type === 'HT'
              ? this.$t('order.Stayin')
              : this.$t('order.Tobeused'),
          '10': this.$t('order.Completed'),
          '11': this.$t('order.Applicationforrefund'),
          '14': this.$t('order.Toberefunded'),
          '15': this.$t('order.HasRefunded'),
          '21': this.$t('order.Failuretopay'),
          '24': this.$t('order.Failureofrefund'),
          '23': this.$t('order.Refundauditfailed'),
          '31': this.$t('order.Paymentoverdue'),
          '32': this.$t('order.Cancellationoforder')
        }
      },
      refund_order_status: {
        plac: this.$t('order.order_status'),
        val: '',
        options: {
          '11': this.$t('order.Applicationforrefund'),
          '14': this.$t('order.Toberefunded'),
          '15': this.$t('order.HasRefunded'),
          '16': this.$t('order.Partialrefund'),
          '24': this.$t('order.Failureofrefund'),
          '23': this.$t('order.Refundauditfailed')
        }
      },
      is_fullhour: {
        plac: this.$t('order.HotelName'),
        val: '',
        options: [
          {
            id: 1,
            value: this.$t('order.yes')
          },
          {
            id: 2,
            value: this.$t('order.no')
          }
        ]
      },
      product_id: {
        plac: this.$t('order.HotelName'),
        val: '',
        options: [this.$t('hotel.RoyalGarden'), this.$t('hotel.hotel3')]
      },
      client_type: {
        plac: this.$t('order.client_type'),
        val: '',
        options: {
          // '1': this.$t('order.Wechat'),
          '2': this.$t('order.applet')
          // '3': this.$t('order.Computer'),
          // '5': this.$t('order.Otherchannels')
        }
      },
      room_type_list: {
        plac: this.$t('order.client_type'),
        val: '',
        options: {
          1: this.$t('hotel.hotel2'),
          2: this.$t('hotel.hotelr3'),
          3: this.$t('hotel.hotel3')
        }
      },
      chose_time: {
        created_start: {
          val: '',
          plac: this.$t('order.Startingorder')
        },
        created_end: {
          val: '',
          plac: this.$t('order.Deadlineorders')
        },
        start_time_start: {
          val: '',
          plac: this.$t('order.Checktimebegins')
        },
        start_time_end: {
          val: '',
          plac: this.$t('order.Checkdeadline')
        },
        end_time_start: {
          val: '',
          plac: this.$t('order.DepartureBegins')
        },
        end_time_end: {
          val: '',
          plac: this.$t('order.Departuredeadline')
        }
      },
      refund_chose_time: {
        refund_start: {
          val: '',
          plac: this.$t('order.ApplicationBegins')
        },
        refund_end: {
          val: '',
          plac: this.$t('order.Applicationdeadline')
        },
        approvalled_start: {
          val: '',
          plac: this.$t('order.AuditBegins')
        },
        approvalled_end: {
          val: '',
          plac: this.$t('order.Auditdeadline')
        }
      },
      addOrderVisible: false,
      htpath: undefined
    }
  },
  computed: {
    lang() {
      return this.$store.getters.language
    }
  },
  watch: {
    lang() {
      this.order_status = {
        plac: this.$t('order.order_status'),
        val: '',
        options: {
          '0': this.$t('order.Tobesubmitted'),
          '2': this.$t('order.Tobepaid'),
          '3': this.$t('order.confirmed'),
          '4':
            this.listquery.filter.type === 'HT'
              ? this.$t('order.Stayin')
              : this.$t('order.Tobeused'),
          '10': this.$t('order.Completed'),
          '11': this.$t('order.Applicationforrefund'),
          '14': this.$t('order.Toberefunded'),
          '15': this.$t('order.HasRefunded'),
          '16': this.$t('order.Partialrefund'),
          '21': this.$t('order.Failuretopay'),
          '24': this.$t('order.Failureofrefund'),
          '23': this.$t('order.Refundauditfailed'),
          '31': this.$t('order.Paymentoverdue'),
          '32': this.$t('order.Cancellationoforder')
        }
      }
      this.refund_order_status = {
        plac: this.$t('order.order_status'),
        val: '',
        options: {
          '11': this.$t('order.Applicationforrefund'),
          '14': this.$t('order.Toberefunded'),
          '15': this.$t('order.HasRefunded'),
          '16': this.$t('order.Partialrefund'),
          '24': this.$t('order.Failureofrefund'),
          '23': this.$t('order.Refundauditfailed')
        }
      }
      this.product_id = {
        plac: this.$t('order.HotelName'),
        val: '',
        options: [this.$t('hotel.RoyalGarden'), this.$t('hotel.hotel3')]
      }
      this.client_type = {
        plac: this.$t('order.client_type'),
        val: '',
        options: {
          // '1': this.$t('order.Wechat'),
          '2': this.$t('order.applet')
          // '3': this.$t('order.Computer'),
          // '5': this.$t('order.Otherchannels')
        }
      }
      this.chose_time = {
        created_start: {
          val: '',
          plac: this.$t('order.Startingorder')
        },
        created_end: {
          val: '',
          plac: this.$t('order.Deadlineorders')
        },
        start_time_start: {
          val: '',
          plac: this.$t('order.Checktimebegins')
        },
        start_time_end: {
          val: '',
          plac: this.$t('order.Checkdeadline')
        },
        end_time_start: {
          val: '',
          plac: this.$t('order.DepartureBegins')
        },
        end_time_end: {
          val: '',
          plac: this.$t('order.Departuredeadline')
        }
      }
      this.refund_chose_time = {
        refund_start: {
          val: '',
          plac: this.$t('order.ApplicationBegins')
        },
        refund_end: {
          val: '',
          plac: this.$t('order.Applicationdeadline')
        },
        approvalled_start: {
          val: '',
          plac: this.$t('order.AuditBegins')
        },
        approvalled_end: {
          val: '',
          plac: this.$t('order.Auditdeadline')
        }
      }
    }
  },
  created() {
    this.filterName = this.$route.name
    this.htpath = this.$route.meta.test
    this.list_type = this.$route.meta.list_type
    this.offlinorder_type = this.$route.meta.order_type
    if (this.offlinorder_type === 'Effective_order') {
      this.order_status = {
        plac: this.$t('order.order_status'),
        val: '',
        options: {
          '5': this.$t('order.Checkedin'),
          '4': this.$t('order.Stayin'),
          '6': this.$t('order.to_be_confirmed'),
          '10': this.$t('order.Completed')
        }
      }
    } else if (this.offlinorder_type === 'Invalid_orders') {
      this.order_status = {
        plac: this.$t('order.order_status'),
        val: '',
        options: {
          '15': this.$t('order.HasRefunded'),
          '31': this.$t('order.have_expired')
        }
      }
    }
    // console.log.log(this.client_type.options)
    if (this.filterName === 'hotel_order_list') {
      this.room_type()
      // console.log(this.client_type)
      if (this.list_type !== 'ALL') {
        this.order_type('HT')
      }
    } else if (this.filterName === 'club_order_list') {
      this.order_type('CL')
    }
    // console.log(this.listquery)
    // const type = this.$route.meta.type ? this.$route.meta.type : undefined
    // const list_type = this.$route.meta.list_type ? this.$route.meta.list_type : undefined
    // this.listquery.type = type
    // this.listquery.list_type = list_type
  },
  methods: {
    // 筛选
    filter() {
      // console.log(this.listquery)
      this.listquery.page.page = 1
      this.$emit('filter', this.listquery)
    },
    // 导出
    xlsxlist() {
      this.$emit('getxlsxlist', this.listQuery)
    },
    refresh() {
      this.$emit('filter', this.listquery)
    },
    closedialog() {
      this.addOrderVisible = false
    },
    room_type() {
      let data = {}
      hotelRoomelist(data).then(response => {
        this.product_id.options = response.data.hotel

        // console.log(response.data.room)
        // this.room_type_list.options = response.data.room
      })
    },
    order_type(val) {
      let query = { is_offline: 0, type: val }
      validList({ filter: query }).then(response => {
        this.client_type.options = response.data
      })
    },
    /**
     * 完成虚拟单录入
     */
    virtualOrders(query) {
      this.addOrderVisible = false
      this.refresh()
    }
  }
}
</script>

<style scoped>
.w140 {
  width: 140px;
}
</style>
